module.exports = __webpack_public_path__ + "img/dominos.9c53d4ec.png";